<template>
  <div id="view-employee">
    <ul class="collection with-header">
      <li v-if="employeeId!= null" class="collection-header"><h4>{{name}}</h4></li>
      <li class="collection-item">Employee ID: {{employeeId}}</li>
      <li class="collection-item">Department: {{department}}</li>
      <li class="collection-item">Position: {{position}}</li>
    </ul>
    <router-link to="/" class="btn grey">Back</router-link>
    <button @click.prevent="deleteEmployee" class="btn red">Delete </button>
    <div class="fixed-action-btn">
      <router-link v-bind:to="{name: 'Edit-Employee', params: {employeeId: employeeId}}" class="btn-floating btn-large grey">
      <i class="fa fa-pencil"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
import db from "../fbInit";
// import { watch } from "fs";
export default {
  name: "view-employee",
  data() {
    return {
      employeeId: null,
      name: null,
      department: null,
      position: null
    };
  },
  beforeRouteEnter(to, from, next) {
    // ...
    db.collection("employees")
      .where("employeeId", "==", to.params.employeeId)
      .get()
      .then(querySnapShot => {
        querySnapShot.forEach(doc => {
          next(vm => {
            (vm.employeeId = doc.data().employeeId),
              (vm.name = doc.data().name),
              (vm.department = doc.data().department),
              (vm.position = doc.data().position);
          });
        });
      });
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      db.collection("employees").where(
        "employeeId",
        "==",
        this.$route.params.employeeId
      )
      .get()
      .then(querySnapShot => {
        querySnapShot.forEach(doc => {
          this.employeeId = doc.data().employeeId,
          this.name = doc.data().name,
          this.department = doc.data().department,
          this.position = doc.data().position
        })
      })
    },
    deleteEmployee() {
      if(confirm("Are you sure you want to delete this employee?"))
      db.collection('employees').where("employeeId", "==", this.$route.params.employeeId)
      .get()
      .then(querySnapShot => {
        querySnapShot.forEach(doc => {
          doc.ref.delete()
          this.$router.push('/')
        })
      })
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Employee/ViewEmployee.vue